import React from "react";
import {Link} from "react-router-dom";

function NavBar() {
    return (
        <div className="">
            <nav className="navbar navbar-expand-lg border-bottom" style={{ backgroundColor: "#FFF" }}>
                <div className="container">
                    <Link classNames="navbar-brand" to="/">
                        <img src="media/logo.svg" alt="logo" style={{ width: "25%" }} />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        <form className="d-flex" role="search">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="/Signup">Signup</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="/About">About</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="/Products">Products</Link>
                                </li>                            <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="Pricing">Pricing</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="/Support">Support</Link>
                                </li>


                            </ul>

                        </form>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default NavBar;